import PageLayout from '../components/pageLayout';
import UsersBulkEdit from '../components/UsersBulkEdit';

function UsersBulkEditPage() {
    return (
        <PageLayout children={<UsersBulkEdit />} />
    );
}

export default UsersBulkEditPage;
